module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1526-a35ff23c08c180da4768e2d0499db3da.png";